import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ButtonCore } from '@unowmooc/buttons'
import { Text } from '@unowmooc/text'
import StreamlineIcon from '@unowmooc/icons'
import styled from '@emotion/styled'
import Tooltip from '@unowmooc/tooltip'
import Files from '@unowmooc/files/lib/providers'

import { isSupported } from '@unowmooc/files/lib/utils'
import { PortalPreview } from '@unowmooc/files/lib/components/PortalPreview'
import { File } from '@unowmooc/files/lib/components/File'

const Wrapper = styled.div`
  display: flex;
`

const Overpreview = styled.div`
  position: relative;
  display: block;
  height: 123px;
  max-width: 217px;
  flex-shrink: 0;
`

const Overshadow = styled.div`
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;

  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }
`

const SearchIcon = styled(StreamlineIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: white;
  font-size: 40px;
`

const Link = styled.a`
  &:hover {
    text-decoration: none;
  }
`

const Info = styled.div`
  display: flex;
  margin-left: 21px;

  ${({ formatSupported }) =>
    formatSupported
      ? `
    flex-direction: column;

    & > :first-child {
      margin-bottom: 20px;
    }
  `
      : `
    margin-left: 10px;
    align-items: center;

    & > :first-child {
    margin-right: 20px;
  }
`}
`

export class FilePreview extends Component {
  static getDerivedStateFromError() {
    // On met à jour l’état afin que le prochain rendu affiche
    // l’UI de remplacement.
    return { hasError: true }
  }

  constructor(props) {
    super(props)

    this.state = { display: false }
  }

  render() {
    const { isOwner, author, file, onDelete } = this.props
    const { display, hasError } = this.state

    const toggleDisplay = () => this.setState({ display: !display })
    const formatSupported = isSupported(file.mimeType) && !hasError

    const ComponentWrapper = formatSupported
      ? Wrapper
      : ({ children, ...props }) => (
          <Link
            href={Files.toDownloadLink(file.secureUrl)}
            title={file.filename}
            download={file.filename}
            target="comment_dl_file"
          >
            <ButtonCore {...props}>{children}</ButtonCore>
          </Link>
        )

    return (
      <ComponentWrapper variant="secondary" p={16}>
        {formatSupported ? (
          <Overpreview>
            <Overshadow onClick={toggleDisplay}>
              <SearchIcon icon="search" size={40} />
            </Overshadow>
            <PortalPreview display={display} file={file} author={author} onClose={toggleDisplay} />
          </Overpreview>
        ) : (
          <File formatSupported={formatSupported} {...file} />
        )}
        <Info formatSupported={formatSupported}>
          <Text fontWeight="bold" maxWidth={250} textAlign="left" lineHeight="21px">
            {file.filename}
          </Text>
          <Wrapper>
            <Link
              href={Files.toDownloadLink(file.secureUrl)}
              title={file.filename}
              download={file.filename}
              target="comment_dl_file"
            >
              <Tooltip content={<Text i18nKey="commons.download" color="white" size="16px" />} key="commons.download">
                <ButtonCore variant="secondary" size="smallSquare">
                  <StreamlineIcon icon="download" variant="primary" />
                </ButtonCore>
              </Tooltip>
            </Link>
            {isOwner && onDelete && (
              <>
                <Tooltip content={<Text i18nKey="commons.delete" color="white" size="16px" />} key="commons.delete">
                  <ButtonCore ml={10} variant="secondary" size="smallSquare" onClick={onDelete}>
                    <StreamlineIcon icon="bin" variant="error" />
                  </ButtonCore>
                </Tooltip>
              </>
            )}
          </Wrapper>
        </Info>
      </ComponentWrapper>
    )
  }
}

FilePreview.defaultProps = {
  isOwner: false,
  author: {
    avatar: {},
  },
  onDelete: undefined,
}

FilePreview.propTypes = {
  isOwner: PropTypes.bool,
  author: PropTypes.shape(),
  file: PropTypes.shape({
    filename: PropTypes.string.isRequired,
    mimeType: PropTypes.string.isRequired,
    secureUrl: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func,
}

export default FilePreview
